import React from "react";
import Badge from "@material-ui/core/Badge";
import { connect } from "react-redux";
import "./index.css";
import Firebase from "../../firebasehelper";
import { getStringfromSeconds, timefromSeconds } from "../../functions";
import user_avatar from "../../assets/media/user.png";
import HexHover from "../HexHover";
import { formatTimestamp } from "../../Utils/utils";

const warningImg = require("../../assets/media/chatsuite/warning.png");

const LightUser = () => {
  return (
    <div className="membership-description">
      <img src={warningImg} width="30px" alt="warning" />
      <p>light user</p>
    </div>
  );
};
class RequestItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: false,
      latest_date: "",
      focused: 0,
    };
  }
  componentDidMount() {
    const { data } = this.props;
    const { uid, tickets } = data;
    let tickets_arr = Object.values(tickets);
    this.getLatestMessage(uid, tickets_arr);
  }
  componentDidUpdate(prevProps) {
    const { data } = this.props;
    const { uid, tickets } = data;
    if (prevProps.data !== data) {
      let tickets_arr = Object.values(tickets);
      this.getLatestMessage(uid, tickets_arr);
    }
  }
  click = () => {
    const { clickRequest } = this.props;
    const { flag } = this.state;
    clickRequest();
    this.setState({ flag: !flag });
  };
  getColorByStatus(status) {
    switch (status) {
      case "Open":
        return "#7Ef0a7";
      case "Waiting":
        return "#FFD366";
      case "Closed":
        return "red";
      default:
        return "green";
    }
  }
  clickTicketDetail = (item, index) => {
    this.setState({ focused: index });
    this.props.clickDetail(item);
  };
  clickTicket = (item, index, isNew) => {
    const { clickTicket, brand, data } = this.props;
    const { ticket_id } = item;
    const { uid } = data;
    const id = brand.name + "_" + uid + "_" + ticket_id;
    if (isNew) Firebase.readUnReadMessages(brand.name, id);
    // unreads.forEach(unread=>{
    //   const {id} = unread;
    //   const uid = id.split("_")[1];
    //   const ticket_id = parseInt(id.split("_")[2],10);
    //   if(uid!==data.uid||ticket_id!==parseInt(item.ticket_id,10))
    //     filtered.push(unread);
    // });
    // this.props.dispatch(saveUnreadSupportMessages([...filtered]));
    this.setState({ focused: index });
    clickTicket(item);
  };
  getLatestMessage = (uid, tickets) => {
    let promises = tickets.map(async (ticket) => {
      const { ticket_id } = ticket;
      let chat_time = await Firebase.getLatestChatTimebyID(uid, ticket_id);
      if (chat_time === 0) chat_time = parseInt(ticket.time);

      return chat_time;
    });
    Promise.all(promises).then((result) => {
      let max = result[0];
      for (let i = 0; i < result.length; i++) {
        if (result[i] > max) max = result[i];
      }

      const date = formatTimestamp(max);
      this.setState({ latest_date: date });
    });
  };
  showTickets = (tickets) => {
    const { focused } = this.state;
    const { ticket_opened, data: user_data, unreads, brand } = this.props;
    const HexButton = HexHover("button", brand.hex);

    let ticketID_List = unreads
      .map((unread) => unread.id)
      .filter((id) => id.split("_")[1] === user_data.uid)
      .map((id) => parseInt(id.split("_")[2], 10));
    console.log("tickets", tickets);
    return tickets.map((item, index) => {
      if (!item.ticket_id || !item.title || !item.time) {
        return null;
      }
      const ticketId = item.ticket_id;
      const tktStr = (ticketId + "").split(".").join("");
      const isNew = ticketID_List.includes(parseInt(tktStr, 10));
      return (
        <div
          key={index}
          style={{
            background: ticket_opened
              ? focused === index
                ? "#9F9E9E"
                : "#152439"
              : "#152439",
            color: "white",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            boxShadow: "-1.7px 4.7px 20px 0 rgba(21, 36, 57, 0.1)",
            paddingLeft: 10,
            paddingRight: 10,
          }}
          className="ticket"
          onClick={() => this.clickTicket(item, index, isNew)}
        >
          <div style={{ maxWidth: 500, display: "flex", flexDirection: "row" }}>
            <p>{item.time && getStringfromSeconds(item.time)}</p>
            <p>
              &nbsp;&nbsp;&nbsp;<b>Ticket</b>&nbsp;:&nbsp;
              {item.title === "Support"
                ? "Support"
                : `Concierge: ${item.title}`}
            </p>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: 300,
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <p
              style={{
                color: isNew ? "#ffcfff" : this.getColorByStatus(item.status),
              }}
            >
              {timefromSeconds(item.time)}
            </p>
            <p
              style={{
                color: isNew ? "#ffcfff" : this.getColorByStatus(item.status),
                fontWeight: "bold",
                fontStyle: isNew ? "italic" : "normal",
                fontSize: 10,
              }}
            >
              {isNew ? "New" : item.status}
            </p>
            <HexButton
              type="button"
              className="btn btn-light text-dark"
              data-toggle="modal"
              data-target="#ticket_detail"
              onClick={() => this.clickTicketDetail(item, index)}
              style={{
                cursor: "pointer",
                height: 30,
                borderRadius: 6,
                color: "#152439",
                padding: "0px 12px",
              }}
            >
              {this.props.buttonName ? this.props.buttonName : "Ticket Details"}
            </HexButton>
          </div>
        </div>
      );
    });
  };
  countMissedMessages = () => {
    const { data: user_data, unreads } = this.props;
    let count = 0;
    unreads.forEach((element) => {
      const { id } = element;
      let uid = id.split("_")[1];
      if (user_data.uid === uid) count++;
    });
    return count;
  };
  render() {
    const { data, clicked, brand } = this.props;
    const count = this.countMissedMessages();
    let { username, tickets, avatar_url, phonenumber } = data;
    const { latest_date } = this.state;
    const tickets_arr = Object.values(tickets).sort((a, b) => b.time - a.time);
    avatar_url = avatar_url || user_avatar;
    return (
      <div>
        <div
          className="block-content"
          onClick={this.click}
          style={{ background: clicked ? "#f4f6fa" : "white" }}
        >
          <div className="row_div">
            {count > 0 && (
              <Badge badgeContent={count} color="primary">
                <div
                  className="avatar"
                  style={{ backgroundImage: `url(${avatar_url})` }}
                />
              </Badge>
            )}
            {count === 0 && (
              <div
                className="avatar"
                style={{ backgroundImage: `url(${avatar_url})` }}
              />
            )}
            <p className="request-item__username">{username}</p>
          </div>
          {!phonenumber && <LightUser />}
          <p className="request-item__date">{latest_date}</p>
        </div>
        {clicked && this.showTickets(tickets_arr)}
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    unreads: state.unreads,
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(RequestItem);



// WEBPACK FOOTER //
// ./src/components/RequestItem/index.js